var React = require('react');

function Facebook (props) {
    return React.createElement("svg",props,React.createElement("path",{"d":"M28 16.5C28 10.1487 22.8513 5 16.5 5C10.1487 5 5 10.1487 5 16.5C5 22.2399 9.20536 26.9976 14.7031 27.8603V19.8242H11.7832V16.5H14.7031V13.9664C14.7031 11.0842 16.42 9.49219 19.0468 9.49219C20.3047 9.49219 21.6211 9.7168 21.6211 9.7168V12.5469H20.171C18.7425 12.5469 18.2969 13.4334 18.2969 14.3438V16.5H21.4863L20.9765 19.8242H18.2969V27.8603C23.7946 26.9976 28 22.2399 28 16.5Z","fill":"black"}));
}

Facebook.defaultProps = {"width":"33","height":"33","viewBox":"0 0 33 33","fill":"none"};

module.exports = Facebook;

Facebook.default = Facebook;
